export default class Address {
    constructor(houseNo, street, locality, city, county, postcode, objectId,parentObjectId,parentObjectHistoryId) {
      this.houseNo = houseNo;
      this.street = street;
      this.locality = locality;
      this.city = city;
      this.county = county;
      this.postcode = postcode;
      this.objectId = objectId;
      this.parentObjectId = parentObjectId;
      this.parentObjectHistoryId = parentObjectHistoryId;
    }
  }
  
